var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50 -883)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(50 883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56 888.15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.85)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.079,17.5H2.27a.757.757,0,0,1-.757-.757V3.12a.757.757,0,0,1,.757-.757H9.079a.757.757,0,0,0,0-1.513H2.27A2.273,2.273,0,0,0,0,3.12V16.739a2.273,2.273,0,0,0,2.27,2.27H9.079a.757.757,0,0,0,0-1.513Z",
    transform: "translate(0 -0.85)",
    fill: "#006"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.053 4.633)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M182.041,111.922l-4.6-4.54a.757.757,0,1,0-1.062,1.077l3.287,3.244h-8.809a.757.757,0,0,0,0,1.513h8.809l-3.287,3.244a.756.756,0,1,0,1.062,1.077l4.6-4.54a.756.756,0,0,0,0-1.077Z",
    transform: "translate(-170.1 -107.165)",
    fill: "#006"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.afff2c74f558a4958ec126907618887b.svg";
export { ForwardRef as ReactComponent };